module.exports = __webpack_public_path__ + "static/media/bus~hOVwqfrj.774d158a.svg";